<template>
  <div id="boardvisor">
    <md-modal id="modalRecursos" v-if="/* this.$route.params.u1 !== 'only' && */tokens.length > 0" class="modal-fixed-footer">
      <ul class="collection with-header">
          <li class="collection-header">
              <h4>Recursos<md-icon v-if="this.isOwner()" class="right" @click="deleteResource()">delete</md-icon></h4>
      </li>
      <div v-for="u in tokens" :key="u.url">
        <div v-if="u.type === 'youtube'">
          <div class="video-container">
              <iframe sandbox="allow-same-origin allow-scripts allow-popups allow-forms" :src="u.url" frameborder="0" allowfullscreen style="text-align: center; max-height: 400px;"></iframe>
          </div>
          <div class="collection-item">
            <a target="_blank" href="{{ u.url }}"><md-icon left>ondemand_video</md-icon><span>{{ u.name }}</span><span> ( {{ u.url }} )</span></a>
          </div>
        </div>
        <div v-else>
        <div v-if="u.type === 'image'">
          <img class="responsive-img" style="text-align: center; max-height: 400px;" :src="u.url" alt="">
          <div class="collection-item">
            <a target="_blank" href="{{ u.url }}"><md-icon left>image</md-icon><span>{{ u.name }}</span><span> ( {{ u.url }} )</span></a>
          </div>
        </div>
        <div v-else>
          <div v-if="u.type === 'pdf'">
            <div class="video-container">
              <iframe sandbox="allow-same-origin allow-scripts allow-popups allow-forms" :src="u.url" loading="lazy" frameborder="0" allowfullscreen></iframe>
            </div>
            <div class="collection-item">
              <a target="_blank" href="{{ u.url }}"><md-icon left>picture_as_pdf</md-icon><span>{{ u.name }}</span><span> ( {{ u.url }} )</span></a>
            </div>
          </div>
          <div v-else>
            <div v-if="u.type === 'pgn'">
              <div class="">
                  <iframe sandbox="allow-same-origin allow-scripts allow-popups allow-forms" :src="getViewPgnUpload(u.url)" frameborder="0" height='340px' autoplay ="true" allowfullscreen="true" scrolling="no" width="100%" allow="camera; microphone"></iframe>
              </div>
              <div class="collection-item">
                <a target="_blank" href="{{ u.url }}"><md-icon left>grid_on</md-icon><span>{{ u.name }}</span><span> ( {{ u.url }} )</span></a>
              </div>
            </div>
            <div v-else>
              <div class="collection-item">
                <a target="_blank" href="{{ u.url }}"><span>{{ u.type }} - {{ u.name }}</span><span> ( {{ u.url }} )</span></a>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
      </ul>
      <span slot="footer">
          <md-button class="waves-effect waves-light red darken-4" style="margin-right: 10px;" @click="this.$broadcast('modal::close', 'some', 'modalRecursos')">
            {{ $t("about.close") }}  <md-icon right>cancel</md-icon><!-- {{ $t("home.createPart.create") }}-->
          </md-button>
      </span>
    </md-modal>
    <div class="col s12">
      <div class="row" style="padding-top: 10px;">
          <div id="content_Visor" class="scrollpurple" v-on:scroll="userScroll" style="height: calc(100vh - 80px); overflow-y: none;">
            <!-- <div :class="this.$route.params.u1 === 'only' ? 'col s8 m8 l8' : 'col s12 m12 l8'">-->
            <div class="col s12 m12 l8">
              <div class="col s12 m12 l12" >
                <audio id="sound" style="display: none;" allow="audio" preload="auto" controls="none">
                  <source src="../../../static/sound/move.mp3" type="audio/mpeg">
                </audio>
                <!--<div class="col s1 m1 l1">
                  <img style="height: 60px;" src="../../../static/images/pieces/merida/wP.svg" alt="">
                </div>-->
                <div v-if="!isHumanVsAnalisis()" style="width:100%">
                  <blockquote v-if="board !== undefined && board.u1 !== undefined" class="chip pulse col s5 m5 l5" style="text-align: left; overflow: hidden; white-space:nowrap; text-overflow:ellipsis;" v-bind:class="[turn === 'white' & times.white > 0 ? 'purple darken-4 userTurn' : '']">
                    <b class="">{{ board !== undefined ? board.u1: '' }}</b>
                    <span class="float: right">{{ times.white | timeBoard }}</span>
                  </blockquote>
                  <div class="col s2 m2 l2" style="text-align: center;">
                    <h5 class="flat-text-header" style="position: relative; top: 15px;">vs</h5>
                  </div>
                  <blockquote v-if="board !== undefined && board.u2 !== undefined" class="chip pulse col s5 m5 l5" style="text-align: left; overflow: hidden; white-space:nowrap; text-overflow:ellipsis;" v-bind:class="[turn === 'black' & times.white > 0 ? 'purple darken-4 userTurn' : '']">
                    <b class="">{{ board !== undefined ? board.u2 : '' }}</b>
                    <span class="" style="float:right" >{{ times.black | timeBoard}}</span>
                  </blockquote>
                  <!--<div class="col s1 m1 l1">
                    <img class="orange" style="height: 60px;float:right;" 
                        src="../../../static/images/pieces/merida/bP.svg" alt="">
                  </div>-->
                </div>
                <div v-else>
                  <blockquote v-if="board !== undefined && board.u1 !== undefined" class="chip pulse col s12 m12 l12 " style="text-align: right;">
                    <div v-if="turn === 'black'">
                      <b class="" > ANALISIS de {{ board !== undefined ? board.u1: '' }}</b>
                      <span :value.sync="times.black"> {{ times.black | timeBoard}} </span>
                    </div>
                    <div v-else>
                      <b class="" v-if="board !== undefined && board.u1 !== undefined"> ANALISIS de {{ board !== undefined ? board.u1: '' }}</b>
                      <span :value.sync="times.black">{{ times.white | timeBoard}}</span>
                    </div>
                  </blockquote>
                </div>
              </div>
              <div class="col s12 m12 l12">
                <div id="middle" :class="(board === undefined || board.pgn === undefined || board.pgn === '') ? 'noboardmiddle' : 'boardmiddle'" :value-sync="board._id">
                  <div class="loadbar" id="analisisVertical" style="display:none;">
                    <strong id="myBar2" class="bar"></strong>
                  </div>  
                  <div id="pgnBoard" class="" style="width: 100%; height: 360px;float:left;" :class="classboard"></div>
                </div>
              </div>
            </div>
            <!-- <div :class="this.$route.params.u1 === 'only' ? 'col s4 m4 l4' : 'col s12 m12 l4'">-->
            <div class="col s12 m12 l4">
              <blockquote class="chip purple darken-4 userTurn" v-if="board !== undefined && board.torneo !== undefined">Torneo: {{ board.torneo }} (Ronda: {{boardShow.ronda + 1}})</blockquote>
              <blockquote v-if="!isHumanVsAnalisis() && board.wins || result.wins"><b v-if="board.wins || result.wins">{{ $t("visor.result") }}: </b>
                <div class="chip">
                  <span>{{ stateGame(board) }}</span>
                </div>
              </blockquote>
              <pgn-header-card :pgn="myPGNValue" :show-metadata="true" compact></pgn-header-card>
              <!-- <div id="pgnHeader" style="max-height: 80px"></div>  -->
              <div id="pgnComment" style="display:none;" ></div>
              <div id="pgnButtons"></div>
              <div id="pgnError"></div>
              <div id="pgnMoves" class="{{!isHumanVsAnalisis() ? '':'comments'}}"></div>

              <textarea style="display:none;" id="idTextAreaPGN" @change="changePGNTextArea()"></textarea>
              <blockquote style="display:none;" ><b class="flat-text-header">PGN: </b><input id='myPGNValue' v-model.lazy="myPGNValue" /></blockquote>
              <blockquote style="display:none;" ><b class="flat-text-header">PGN: </b><input id='myPGNReload' v-model.lazy="myPGNReload" /></blockquote>

              <!--<blockquote><b class="flat-text-header">PGN: </b><input id='myPGNValue' v-model.lazy="myPGNValue" /></blockquote>-->
              <blockquote style="display:none;" ><b class="flat-text-header">FEN: </b><input id='myFENValue' v-model.lazy="myFENValue" /></blockquote>
              <!--<blockquote><b class="flat-text-header">PGN: </b><p id='myPGNValue'></p></blockquote>-->
              <blockquote style="display:none;"><b class="flat-text-header">FEN: </b><span id='myFENValueP'></span></blockquote>
              <board-history v-if="validBoard" :active="!board.wins && !result.wins" :pgn="myPGNValue" :fen="myFENValue" :history="history" :sendtoteacher="sendtoteacher" :userchat="userChat" :user="user" :boardid="board._id" :board="board" :humanvsanalisis="isHumanVsAnalisis" :only="this.$route.params.u1 === 'only'"></board-history>

            <div class="row"></div>
              <div v-if="this.$route.params.u1 !== 'only'" id="content_Chat" class="" v-on:scroll="userScroll" style=""> 
                <div class="col s12 m12 l12">
                  <h6 class="title">{{ $t("home.chattext") }} {{ user.club }} 
                    <span v-if="chatRecibido === true" class="badge green darken-4" style="color:white;">{{ chatRecibido === true ? 'Check' : '' }}</span>
                  </h6>
                  <div class="scrollpurple borderround" style="height: 20vh;overflow: auto;border: 1px solid #5c005c" id="chatConvertGame">
                      <body-men :mens="mensjGame" :dir-server="dirServer" :user="user"></body-men>
                  </div>
                  <form v-if="user.chattext === undefined || user.chattext === true" v-on:submit.prevent="sendMensajeGeneral()">
                    <div class="col s9 m9 l9">
                      <!-- <b class="flat-text-header">{{ $t("game.text") }}</b>-->
                      <input class="left" name="text"  id='textChatInput' v-model.lazy="chattext" />
                    </div>
                    <div class="col s2 m2 l2">
                      <md-btn class="md-button btn-floating btn-flat purple darken-4 btn">
                        <!-- <md-icon>send</md-icon> -->
                        <i class="material-icons small">navigate_next</i>
                      </md-btn> 
                    </div>
                    <div class="col s1 m1 l1">
                      <select class="emojiclass right" v-model.lazy="newEmoji" style="display:inline;width:50px;">
                        <!-- Emoticonos generales -->
                        <option value="&#128077;">&#128077; OK</option> <!-- Pulgar arriba -->
                        <option value="&#128078;">&#128078; No</option> <!-- Pulgar abajo -->
                        <option value="&#128076;">&#128076; Perfecto</option> <!-- Mano haciendo "OK" -->
                        <option value="&#128075;">&#128075; Hola</option> <!-- Mano saludando -->
                        <option value="&#129505;">&#129505; De acuerdo</option> <!-- Apretón de manos -->
                        <option value="&#128591;">&#128591; Gracias</option> <!-- Manos juntas -->
                        <option value="&#128521;">&#128521; Guiño</option>
                        <option value="&#128522;">&#128522; Sonrisa</option>
                        <option value="&#128526;">&#128526; Cool</option>
                        <option value="&#128540;">&#128540; Travieso</option>
                        <option value="&#128545;">&#128545; Enojado</option>
                        <option value="&#128561;">&#128561; Sorprendido</option>
                        <option value="&#128580;">&#128580; Escéptico</option>
                        <!-- Emoticonos de ajedrez -->
                        <option value="&#9812;">&#9812; Rey Blanco</option>
                        <option value="&#9813;">&#9813; Reina Blanca</option>
                        <option value="&#9814;">&#9814; Torre Blanca</option>
                        <option value="&#9815;">&#9815; Alfil Blanco</option>
                        <option value="&#9816;">&#9816; Caballo Blanco</option>
                        <option value="&#9817;">&#9817; Peón Blanco</option>
                        <option value="&#9818;">&#9818; Rey Negro</option>
                        <option value="&#9819;">&#9819; Reina Negra</option>
                        <option value="&#9820;">&#9820; Torre Negra</option>
                        <option value="&#9821;">&#9821; Alfil Negro</option>
                        <option value="&#9822;">&#9822; Caballo Negro</option>
                        <option value="&#9823;">&#9823; Peón Negro</option>
                      </select>        
                      
                      <!-- <md-checkbox :value.sync="sendToAll"><span>A todos</span></md-checkbox>-->
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import Chess from 'chess.js'
import UserService from '../../services/user'
import Store from '../../services/lstorage'
import Board from '../../services/board'
// import config from '../../../server/config.js'
// import Chessground from 'chessground'
// import Garbochess from '../../services/garbochess.js'
// import UserService from '../../services/user'
import BoardHistory from '../game/boardHistory'
import BodyMen from '../home/bodyMen'
import toast from 'vue-material-components'
import { boardGameMove, boardGameTurn, boardGameCountDown } from '../../vuex/actions'
import { getGamePgn, getGameFen, getGameTurn, getGameTimesUsers } from '../../vuex/getters'
import PgnHeaderCard from '../common/PgnHeaderCard.vue'
import Jquery from 'jquery'
// import board from '../../services/board'
var stylesBoard = {
  board: ['maple', 'brownboard', 'marble', 'blueboard', 'greenboard', 'wood'],
  pieces: ['fantasy', 'pirouetti', 'merida', 'cburnett', 'alpha', 'uscf', 'leipzig', 'spatial', 'maestro', 'horsey', 'anarcandy']
}
var timesColor = {
  white: 1,
  black: 1
}
window.pgn = ''
window.ground = 0
window.pgnBoardBase = 0
window.computerGame = 1
window.orientationg = 'white'
export default {
  name: 'BoardVisor',
  props: {
    sendtoteacher: {
      type: Boolean,
      required: false,
      'default': false
    },
    board: {
      type: Object,
      'default': null
    },
    classboard: {
      type: String
    }
  },
  computed: {
    validBoard () {
      return Array.isArray(this.board) ? null : this.board
    }
  },
  data () {
    return {
      result: {},
      boardShow: {},
      history: [],
      chess: new Chess(),
      turn: '',
      userFrom: '',
      activeChat: 'Chat',
      chatRecibido: false,
      fen: '',
      tokens: [],
      chattext: '',
      newEmoji: '',
      mensjGame: [],
      times: {
        black: 300,
        white: 300,
        incremento: 0
      },
      styleboard: true,
      stylesBoard: stylesBoard,
      styles: Store.get('styleBoard',
        {
          board: 0,
          pieces: 0
        }),
      user: UserService.user,
      myFENValue: '',
      myPGNValue: '',
      myPGNReload: '',
      userChat: UserService.user.name,
      Width: 500
    }
  },
  components: {
    BoardHistory,
    BodyMen,
    PgnHeaderCard
  },
  mixins: [
    toast
  ],
  vuex: {
    actions: {
      boardGameMove,
      boardGameTurn,
      boardGameCountDown
    },
    getters: {
      fen: getGameFen,
      pgn: getGamePgn,
      turn: getGameTurn,
      time: getGameTimesUsers
    }
  },
  events: {
    mensajegeneral (data) {
      this.recibeMensaje(data.men, true)
      if (data.men.send !== this.user.username) {
        this.chatRecibido = true
      }
      console.log('EVENT mensajegeneral ')
    },
    move (board) {
      console.log('EVENT move ')
      // setTimeout(function () {
      // this.toast('move home', 6000)
      if (this.boardShow && this.boardShow._id === board.idBoard) {
        if (document.getElementById('searchInput') && document.getElementById('analisisModal').style.display !== 'none') {
          document.getElementById('searchInput').value = window.pgnBoardBase.chess.fen()// window.pgnBoardBase.getPgn().write_pgn()
          // document.getElementById('searchInput').value = window.pgnBoardBase.getPgn().write_pgn()
          document.getElementById('searchInput').dispatchEvent(new window.Event('change'))
        }
        // board.pgn = board.pgn.replace(/\{( *)\}/gmu, '')
        // board.pgn = board.pgn.replace(/\{\[%emt(\s\S.+?)\]\}/gmu, '')
        // console.log('Home move from ' + board.user.username)
        // console.log('Game move to ' + this.boardShow.u1)
        // document.body.dispatchEvent(new window.Event('chessground.resize'))
        // window.alert(board.user.username + ' ' + this.boardShow.u1)
        /* if (this.boardShow.wins && board.idBoard || (board.user !== undefined && board.user.username === this.user.username) ||
        (board.user !== undefined && this.boardShow !== undefined && board.user.username !== this.boardShow.u1)) {
          return
        }*/
        console.log('event move ' + board.move)
        // window.alert(JSON.stringify(board))
        if (this.isHumanVsAnalisis() === false || (board.user !== undefined && board.user.userName !== this.boardShow.u1)) {
          if (board.user !== undefined) {
            this.userFrom = board.user.username
          }
          // this.historyChange = false
          // if (board.idBoard) {
          //   this.historyChange = true
          // }
          // window.alert('boardmove')
          // this.changeStateGame(board, board.move)
          this.changeStateGame(board)
          if (board.times) {
            this.times = board.times
          }
        }
      }
      // }.bind(this), 10)
    },
    getLength (param) {
      var ret = 0
      if (param !== undefined && Object.keys(param) !== undefined) {
        ret = Object.keys(param).length
      }
      console.log('EVENT getLength ')
      return ret
    },
    gameFinish (dataResult) {
      this.stateFinishGame(dataResult)
      console.log('EVENT gameFinish ')
    },
    sendPGNtoTeacher () {
      console.log('EVENT sendPGNtoTeacher ')
      // var idTextArea = document.getElementById('idTextAreaPGN')
      // if (idTextArea && idTextArea.value !== 'none') {
      // window.alert('changePGN: ' + this.myPGNValue + ' FEN - ' + this.myFENValue)
      // comunicacion con servidor
      // console.log(UserService.getUser().username)
      // console.log(this.boardShow.u1)
      var turn = 'w'
      if (window.pgnBoardBase.chess !== undefined) {
        turn = (window.pgnBoardBase.chess.turn() === 'w') ? 'white' : 'black'
      }
      var data = {
        c: 'board',
        f: 'move',
        data: {
          event: 'move',
          data: {
            pgn: this.myPGNValue,
            fen: this.myFENValue,
            idBoard: this.boardShow._id,
            turn: turn,
            times: {},
            user: UserService.getUser()
          }
        }
      }
      // window.alert(JSON.stringify(data.data))
      // this.$dispatch('move', {pgn: this.myPGNValue})
      if (this.$socket !== undefined) {
        this.$socket.emit('event', data, function (...callbacks) {
          // console.log(callbacks)
        })
      }
      this.userFrom = this.user.username
    },
    analizaPGN () {
      this.$broadcast('modal::open', 'invitePCAnalisis')
      console.log('EVENT sendPGNtoTeacher ')
    }
  },
  methods: {
    stateGame (board) {
      if (board.wins === 'draw') {
        var textdraw = 'Tablas' + ' ' + Vue.t('visor.by')
        textdraw += ' '
        textdraw += (board.motiv === 'drawn_position') ? 'positión de tablas' : ((board.motiv === 'insufficient_material') ? 'material insuficiente' : ((board.motiv === 'threefold_repetition') ? 'repetición' : (board.motiv === 'stalemate') ? 'ahogado' : board.motiv))
        return textdraw
      } else {
        var text = Vue.t('visor.wins')
        text += (board.wins === 'white') ? ' blancas ' : ' negras ' + Vue.t('visor.by')
        text += ' '
        text += (board.motiv === 'rendicion') ? 'rendición' : ((board.motiv === 'timeout') ? 'tiempo' : ((board.motiv === 'checkmate') ? 'jaque mate' : board.motiv))
        return text
      }
    },
    sendMensajeGeneral () {
      if (this.chattext === '') {
        return
      }
      var thisUser = this.user.username
      var otherUser = this.board.u1 === thisUser ? this.board.u2 : this.board.u1
      var men = {
        body: this.chattext,
        type: 'text',
        public: true,
        all: true,
        club: this.user.club,
        board: this.user.club, // this.board._id,
        send: thisUser,
        recibe: otherUser
      }
      var data = {
        c: 'chat',
        f: 'mensajegeneral',
        data: {
          men: men
        }
      }
      this.$socket.emit('event', data, function (...callbacks) {
        // console.log(callbacks)
      })
      this.chattext = ''
      this.isAtBottom()
    },
    loadUserConvert (parms, historyTop = false) {
      try {
        var data = {
          c: 'chat',
          f: 'loadUserConvert',
          data: parms
        }
        this.$socket.emit('event', data, function (...callbacks) {
          var log = callbacks[1]
          this.mensjGame = []
          var menLast = ''
          if (log) {
            for (var i = log.length - 1; i >= 0; i--) {
              if (menLast !== log[i].body || menLast === '') {
                this.recibeMensaje(log[i], false)
                menLast = log[i].body
              }
            }
          }
          this.isAtBottom()
        }.bind(this))
      } catch (error) {
      }
    },
    userScroll (e) {
      var scrollTop = e.target.scrollTop
      // var scrollWidth = e.target.scrollWidth
      // var scrollHeight = e.target.scrollHeight
      // var clientHeight = e.target.clientHeight
      // console.log(scrollTop, scrollWidth, scrollHeight, clientHeight)
      // window.alert('c')
      if (scrollTop === 0) {
        var post = this.foundTab(this.active)
        // console.log('cargar historial anterior', this.active)
        var parmsLoad = {
          user: this.active,
          range: {
            limit: 100,
            skip: this.tabs[post].men.length
          }
        }
        // window.alert('userScroll')
        this.loadUserConvert(parmsLoad, true)
      }
    },
    isAtBottom () {
      var chatConvert = document.getElementById('chatConvertGame')
      if (chatConvert) {
        this.scrollBottom()
      }
    },
    scrollBottom () {
      Jquery('#chatConvertGame').animate({
        'scrollTop': Jquery('#chatConvertGame')[0].scrollHeight
      }, 'fast')
    },
    recibeMensaje (men, bottom = false, toast = true) {
      // var idDiv = 'chatConvertGame'
      // var divScroll = document.getElementById(idDiv)
      // var atBottom = divScroll.scrollTop >= divScroll.scrollHeight - divScroll.clientHeight
      // window.alert(this.user.club)
      if (men.board === this.user.club) {
        this.mensjGame.push(men)
        if (bottom) {
          this.isAtBottom()
        }
      }

      /* if (toast === true) {
        if (men.send !== UserService.getUser().username) {
          this.toast('<span>' + men.send + ': ' + men.body + '</span>', 1000)
        }
      }*/
    },
    GetFilename (url) {
      var filename = url.substring(url.lastIndexOf('/') + 1)
      return filename
    },
    getViewPgnUpload (url) {
      var dirServer = Store.get('serverDir')
      var fileName = dirServer + '/uploads/' + this.GetFilename(url)
      // window.alert(dirServer)
      return dirServer + '/#!/visor/0/0/only/' + fileName
    },
    soundPlay () {
      var sonido = document.getElementById('sound')
      if (sonido) {
        sonido.play()
      }
    },
    onResize (event) {
      /* if (document.getElementById('middle') && document.getElementById('pgnBoard') && document.getElementById('pgnBoard').style) {
        this.Width = document.getElementById('middle').clientWidth
        this.Width = this.Width > window.innerHeight - 100 ? window.innerHeight - 100 : this.Width// document.getElementById('middle').clientWidth
        // window.alert(this.Width)
        if (document.getElementById('analisisVertical') && document.getElementById('analisisVertical').style.display !== 'none') {
          this.Width = this.Width - 20
        }
        document.getElementById('pgnBoard').style.height = this.Width + 'px'
        document.getElementById('pgnBoard').style.width = this.Width + 'px'
        document.getElementById('analisisVertical').style.height = this.Width + 'px'
        // Jquery('#pgnBoard').load(window.location.href + '#pgnBoard')
        // this.toast('<span>Width: ' + Width + '</span>', 2000, 'rounded')
        document.body.dispatchEvent(new window.Event('chessground.resize'))
      }*/
      this.resizeBoard()
    },
    deleteResource (resource) {
      // window.alert('Borrando: ' + resource.url)
      /* var itemToDelete = ''
      this.board.urls.replace(/\{(.*?)}/g, function (a, b) {
        // window.alert(JSON.stringify(b))
        if (b.indexOf(resource.url) > 0) {
          itemToDelete = b
          // window.alert('encontrado')
        }
      })
      this.board.urls = this.board.urls.replace('{' + itemToDelete + '}', '')
      // window.alert(this.board.urls)*/
    },
    changeOrientation () {
      // window.ground = Chessground(document.getElementById('boardInner'))
      window.orientationg = window.orientationg === 'white' ? 'black' : 'white'
      window.ground.set({
        orientation: window.orientationg,
        drawable: {
          enabled: true,
          visible: true
        }
      })
    },
    isHumanVsAnalisis () {
      return (this.board !== undefined && this.board.u1 === this.board.u2)
    },
    stateFinishGame (state) {
      if (state.board._id === this.board._id) {
        this.result = {
          wins: state.result.color,
          motiv: state.result.motiv
        }
        clearInterval(timesColor.black)
        clearInterval(timesColor.white)
      }
    },
    hasBody (pgn) {
      var ret = false
      var newlineChar = '\r?\n'
      var lines = pgn.split(new RegExp(newlineChar))
      for (var i = 0; i < lines.length; i++) {
        // window.alert(lines[i])
        var linea = lines[i].trim()
        if (linea.length > 0 && linea[0] !== '['/* && lines[i].includes('.') */ && linea[0] !== '*') {
          // window.alert(linea)
          ret = true
          break
        }
      }
      return ret
    },
    parse_pgn_header (header) {
      var newlineChar = '\r?\n'
      var headerObj = {}
      var headers = header.split(new RegExp(newlineChar))
      var key = ''
      var value = ''
      for (var i = 0; i < headers.length; i++) {
        key = headers[i].replace(/^\[([A-Z][A-Za-z]*)\s.*\]$/, '$1')
        value = headers[i].replace(/^\[[A-Za-z]+\s"(.*)"\]$/, '$1')
        if (key.length > 0 && value.length > 0 && key !== value) {
          headerObj[key] = value
        }
      }
      return headerObj
    },
    changePGNTextArea () {
      var idTextArea = document.getElementById('idTextAreaPGN')
      if (idTextArea && idTextArea.value !== 'none') {
        var pgnAux = idTextArea.value
        // pgnAux = this.prettyPgn(pgnAux)
        // pgnAux = pgnAux.replace(/\{( *)\}/gmu, '')
        // pgnAux = pgnAux.replace(/\{\[%emt(\s\S.+?)\]\}/gmu, '')
        this.myPGNValue = pgnAux
        // this.parsePgnFiles(idTextArea.value)
        // this.changePGN()
        var headers = this.parse_pgn_header(idTextArea.value)
        if (headers['FEN'] !== undefined && headers['FEN'] !== null) {
          this.myFENValue = headers['FEN']
          // window.alert(headers['FEN'])
        }
        // this.toast('changePGNTextArea', 5000)
        // window.alert(idTextArea.value)
        this.board.pgn = idTextArea.value
        this.changeStateGame(this.board)
        idTextArea.value = ''
        var buttonLast = document.getElementById('pgnButtonslast')
        if (buttonLast) {
          buttonLast.click()
        }
      }
      // this.$dispatch('move', {pgn: this.myPGNValue})
      // }
    },
    changePGN () {
      // var idTextArea = document.getElementById('idTextAreaPGN')
      // if (idTextArea && idTextArea.value !== 'none') {
      // window.alert('changePGN: ' + this.myPGNValue + ' FEN - ' + this.myFENValue)
      // comunicacion con servidor
      // if (UserService.getUser().username !== this.board.userWhite) {
      var turn = (this.chess.turn() === 'w') ? 'white' : 'black'
      var data = {
        c: 'board',
        f: 'move',
        data: {
          event: 'move',
          data: {
            urls: this.board.urls,
            pgn: this.myPGNValue,
            fen: this.myFENValue,
            idBoard: this.board._id,
            turn: turn,
            times: {},
            user: UserService.getUser()
            /* move: {
              from: '',
              to: ''
            }*/
          }
        }
      }
      // window.alert('changePGN')
      this.$socket.emit('event', data, function (...callbacks) {
        // console.log(callbacks)
      })
      // this.chess.load_pgn(this.myPGNValue)
      // this.soundPlay()
    // }
      // this.$dispatch('move', {pgn: this.myPGNValue})
      // }
    },
    onMove (orig, dest) {
      // comprobar si el juego esta activo
      // window.alert('onMove HOme' + orig + ' ' + dest)
      if (this.active || true) {
        var promopiece = 'q'
        /* if ((dest.includes('8') || dest.includes('1')) && this.chess.get(orig).type === 'p') {
          // this.$broadcast('modal::open', 'piecePromotion')
          promopiece = window.prompt('Promocionar pieza (q / b / r / n):', 'q')
          // window.alert(promopiece)
        }*/
        this.chess.move({
          from: orig,
          to: dest,
          promotion: promopiece
        })
        this.posiblecancel = this.chess.history().length <= 2
        // window.alert(this.chess.history().length)
        var data = 0
        var turn = (this.chess.turn() === 'w') ? 'white' : 'black'
        var myTurn = this.user.username === this.board.u1 ? 'white' : 'black'
        if (this.isHumanVsAnalisis()) {
          // window.alert(window.pgnBoardBase.getPgn().write_pgn())
          // comunicacion con servidor
          data = {
            c: 'board',
            f: 'move',
            data: {
              event: 'move',
              data: {
                pgn: this.myPGNValue,
                fen: this.myFENValue,
                idBoard: this.board._id,
                userTurn: myTurn,
                turn: turn,
                times: {},
                move: {
                  from: orig,
                  to: dest
                }
              }
            }
          }
          if (this.$socket !== undefined) {
            // this.$dispatch('move', {pgn: this.myPGNValue})
            this.$socket.emit('event', data, function (...callbacks) {
              // console.log(callbacks)
            })
          }
        } else {
          // window.alert(this.myFENValue)
          // window.alert(window.pgnBoardBase.getPgn().write_pgn())
          // comunicacion con servidor
          data = {
            c: 'board',
            f: 'move',
            data: {
              event: 'move',
              data: {
                pgn: this.chess.pgn(), // window.pgnBoardBase.getPgn().write_pgn(),
                fen: this.chess.fen(),
                idBoard: this.board._id,
                userTurn: myTurn,
                turn: turn,
                times: {},
                move: {
                  from: orig,
                  to: dest
                }
              }
            }
          }
          if (this.$socket !== undefined) {
            this.$socket.emit('event', data, function (...callbacks) {
              // console.log(callbacks)
            })
          }
        }
        // this.isVsPc(turn)
      }
    },
    isOwner () {
      return this.user.username === this.board.u1 || this.user.username === this.board.u2
    },
    isPgnFile (path) {
      return /\.pgn$/i.test(path)
    },
    changeStateGame (board, only = false) {
      // this.toast(board.pgn, 6000)
      // setTimeout(function () {
      try {
        if (only === false && (board === undefined || board.pgn === undefined || board.pgn === '')) {
          return
        }
        if (only === false) {
          board.pgn = board.pgn.split('"]').join('"]\n')
          // board.pgn = board.pgn.split('{}').join('')
          window.pgn = board.pgn
          // window.alert(board.pgn)
          // this.fen = this.myFENValueP // this.chess.fen()
          // this.chess.load_pgn(board.pgn)
          // console.log(this.chess.undo())
          if (board.move !== undefined) {
            window.ground.move(board.move.from, board.move.to)
            // this.chess.move(board.move.from, board.move.to)
          } else {
            this.chess.load_pgn(board.pgn)
          }
        }
        if (window.ground) {
          window.ground.set({
            fen: this.chess.fen(),
            orientation: window.orientationg,
            drawable: {
              enabled: true,
              visible: true
            }
          })
        }
        // if (this.historyChange) {
        //   this.history = this.chess.history({ verbose: true })
        // }
        var pos = 'end' // board.fen !== undefined ? board.fen : 'end'
        // window.alert(this.$route.path)
        if (this.$route.path.includes('/lesson')) {
          pos = 'start'
        }
        var start = ''
        if (only === false) {
          start = board.fen !== undefined ? board.fen : ''
          board.pgn = board.pgn.split('"]').join('"]\n')
          // board.pgn = board.pgn.split('{}').join('')
          // window.alert(JSON.stringify(board.pgn))
          var headers = this.parse_pgn_header(board.pgn)
          if (headers['FEN'] !== undefined && headers['FEN'] !== null) {
            pos = board.fen !== undefined ? board.fen : 'end'
            if (!this.hasBody(board.pgn)) {
              start = ''
              pos = headers['FEN']
            }
            if (pos === headers['FEN']) {
              start = ''
            }
          }
          if (start === 'start' || start === 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1') {
            start = ''
            pos = board.fen
          }
          console.log(pos)
          /* var start = ''
          if (board.fen !== undefined && window.pgnBoardBase.getPgn().write_pgn().length > 0) {
            start = board.fen
          } else {
            start = ''
          }
          var headers = this.parse_pgn_header(board.pgn)
          if (headers['FEN'] !== undefined && headers['FEN'] !== null) {
            board.fen = headers['FEN']
            start = ''
          }*/
        }
        // window.alert(board.fen)
        if (document.getElementById('pgnMoves')) {
          document.getElementById('pgnMoves').textContent = ''
        }
        if (document.getElementById('pgnButtons')) {
          document.getElementById('pgnButtons').textContent = ''
        }
        if (document.getElementById('pgnComment')) {
          document.getElementById('pgnComment').textContent = ''
        }
        /* if (document.getElementById('pgnHeader')) {
          document.getElementById('pgnHeader').textContent = ''
        } */
        if (document.getElementById('pgnError')) {
          document.getElementById('pgnError').textContent = ''
        }
        var pgnBoard = 0
        window.orientationg = this.isHumanVsAnalisis() === false && this.user.username === this.board.u2 ? 'black' : 'white'
      /*  var pos = ''
        if (start === '' && board.fen !== undefined) {
          pos = board.fen
        } else {
          pos = ''
        }*/
        // window.alert('startplay: ' + start + 'pos: ' + pos + 'FEN: ' + headers['FEN'])
        if (only === false) {
          if (start === headers['FEN']) {
            start = ''
          }
        }
        // window.alert('pos: ' + pos)
        // this.toast('<span> BoardVisor: ' + pos + '</span>', 6000, 'rounded')
        // this.toast('<span>' + pos + '</span>', 2000, 'rounded')
        var winWidth = Math.min(window.innerWidth, window.outerWidth)
        this.resizeBoard()
        if (this.$route.params.u2 !== '' && this.$route.params.u1 === 'only') {
          if (this.isPgnFile(this.$route.params.u2)) {
            var dirServer = Store.get('serverDir')
            // window.alert(dirServer + '/uploads/' + this.$route.params.u2)
            let ruta = dirServer + '/uploads/' + this.$route.params.u2 // this.$route.params.u2.replace(/--/g, '/')
            // let ruta = this.$route.params.u2
            // window.alert(ruta)
            pgnBoard = window.pgnView({inner: 'pgnBoard', moves: 'pgnMoves', comment: 'pgnComment', button: 'pgnButtons', fen: 'pgnFen', error: 'pgnError'}, {pgnFile: ruta, startPlay: start, position: pos, hideMovesBefore: false, movesWidth: '90%', showFen: true, colorMarker: 'cm-small', locale: 'es', orientation: window.orientationg, width: this.Width, coordsFactor: 0.6, coordsInner: winWidth < 600, headers: false})
          } else {
            if (board.pgn !== 'none') {
              pgnBoard = window.pgnEdit({inner: 'pgnBoard', moves: 'pgnMoves', comment: 'pgnComment', button: 'pgnButtons', fen: 'pgnFen', error: 'pgnError'}, {pgn: board.pgn, startPlay: start, position: 'end', movesWidth: '90%', showFen: true, colorMarker: 'cm-small', locale: 'es', orientation: window.orientationg, width: this.Width, coordsFactor: 0.6, coordsInner: winWidth < 600, headers: false})
            } else {
              pgnBoard = window.pgnEdit({inner: 'pgnBoard', moves: 'pgnMoves', comment: 'pgnComment', button: 'pgnButtons', fen: 'pgnFen', error: 'pgnError'}, {position: 'start', movesWidth: '90%', showFen: true, colorMarker: 'cm-small', locale: 'es', orientation: window.orientationg, width: this.Width, coordsFactor: 0.6, coordsInner: winWidth < 600, headers: false})
            }
          }
        } else {
          if ((this.isOwner() === false || this.boardShow.wins) || this.isHumanVsAnalisis()) {
            if (board.pgn !== 'none') {
              pgnBoard = window.pgnEdit({inner: 'pgnBoard', moves: 'pgnMoves', comment: 'pgnComment', button: 'pgnButtons', fen: 'pgnFen', error: 'pgnError'}, {pgn: board.pgn, startPlay: start, position: pos, hideMovesBefore: false, movesWidth: '90%', showFen: true, colorMarker: 'cm-small', locale: 'es', orientation: window.orientationg, coordsFactor: 0.6, width: this.Width, coordsInner: winWidth < 600, headers: false})
            } else {
              pgnBoard = window.pgnEdit({inner: 'pgnBoard', moves: 'pgnMoves', comment: 'pgnComment', button: 'pgnButtons', fen: 'pgnFen', error: 'pgnError'}, {position: 'start', movesWidth: '90%', showFen: true, colorMarker: 'cm-small', locale: 'es', orientation: window.orientationg, width: this.Width, coordsFactor: 0.6, coordsInner: winWidth < 600, headers: false})
            }
          } else {
            if (board.pgn !== 'none') {
              pgnBoard = window.pgnEdit({inner: 'pgnBoard', fen: 'pgnFen', comment: 'pgnComment', error: 'pgnError'}, {pgn: board.pgn, startPlay: start, position: 'end', movesWidth: '90%', showFen: true, colorMarker: 'cm-small', locale: 'es', orientation: window.orientationg, width: this.Width, coordsFactor: 0.6, coordsInner: winWidth < 600, headers: false})
            } else {
              pgnBoard = window.pgnEdit({inner: 'pgnBoard', fen: 'pgnFen', comment: 'pgnComment', error: 'pgnError'}, {position: 'start', movesWidth: '90%', showFen: true, colorMarker: 'cm-small', locale: 'es', orientation: window.orientationg, width: this.Width, coordsFactor: 0.6, coordsInner: winWidth < 600, headers: false})
            }
          }
        }
        window.pgnBoardBase = pgnBoard.boardBase
        window.ground = pgnBoard.board
        // this.soundPlay()
        this.chessToColor(window.pgnBoardBase.chess)
        /* var options = {
          fen: this.board.fen
        }
        window.ground.set(options)*/
        // document.getElementById('pgnBoard').style.height = this.Width + 'px'
        // document.getElementById('pgnBoard').style.width = this.Width + 'px'
        // this.userFrom = ''
        if (this.isHumanVsAnalisis() === false && this.isOwner()) {
          var preMove = window.ground !== undefined && window.ground.state !== undefined && window.ground.state.premovable !== undefined ? window.ground.state.premovable.current : null
          var myTurn = this.user.username === this.board.u1 ? 'w' : 'b'
          // window.alert(this.chessToColor(this.chess))
          window.ground.set({
            fen: this.chess.fen(),
            turnColor: this.chess.turn() === myTurn ? this.chessToColor(this.chess) : this.chessToColorVs(this.chess),
            movable: {
              // -- Para el análisis
              // free: true,
              color: this.chessToColor(this.chess),
              premove: true,
              dests: this.chessToDests(this.chess)
            },
            disableContextMenu: true,
            highlight: {
              lastMove: true,       // add last-move class to squares
              check: true          // add check class to squares
            },
            events: {
              move: this.onMove
            },
            premovable: {
              enabled: true,
              showDests: true,
              current: preMove
            },
            drawable: {
              enabled: true,
              visible: true
            },
            resizable: true
          })
          window.ground.playPremove()
        }
        const comments = document.querySelectorAll('.afterComment')
        comments.forEach((comment) => {
          // Verifica si el texto del comentario contiene el emoji 🎥
          const textResource = comment.textContent.toLowerCase()
          if (textResource.includes('🎥') || textResource.includes('vídeo') || textResource.includes('recurso') || textResource.includes('video')) {
            // Añade la clase .highlight-move al elemento padre con clase .move
            comment.closest('.move').classList.add('highlight-move')
          }
        })
        /* var buttonLast = document.getElementById('pgnButtonslast')
        if (buttonLast) {
          buttonLast.click()
        } */
        // this.checkResources(this.chess.fen())
        // this.resizeBoard()
      } catch (error) {
        // this.toast('<span>' + 'Error (changeStateGame): ' + error + '</span>', 3000)
        console.error('<span>' + 'Error Mainchess (changeStateGame): ' + error + '</span>', 3000)
      }
      // }.bind(this), 200)
    },
    toggleOrientation () {
      // window.alert('')
    },
    chessToDests (chess) {
      var dests = {}
      chess.SQUARES.forEach(function (s) {
        var ms = chess.moves({square: s, verbose: true})
        if (ms.length) dests[s] = ms.map(function (m) { return m.to })
      })
      return dests
    },
    chessToColorVs (chess) {
      var turn = this.chessToColor(chess) === 'black' ? 'white' : 'black'
      return turn
    },
    countDown () {
      clearInterval(timesColor[this.turn])
      timesColor[this.turn] = setInterval(function () {
        this.times[this.turn] = this.times[this.turn] - 1
        if (this.times[this.turn] <= 0) {
          clearInterval(timesColor.white)
          clearInterval(timesColor.black)
          this.times[this.turn] = 0
        }
      }.bind(this), 1000)
    },
    chessToColor (chess) {
      var t = chess.turn()
      var turn = (t === 'w') ? 'white' : 'black'
      this.boardGameTurn(turn)
      turn = this.user.username === this.board.u2 ? 'black' : 'white'
      return turn
      /* if (chess !== undefined) {
        var t = chess.turn()
        this.turn = (t === 'w') ? 'white' : 'black'
      }*/
    },
    getRandomInt (min, max) {
      min = Math.ceil(min)
      max = Math.floor(max)
      return Math.floor(Math.random() * (max - min + 1)) + min
    },
    readTextFile (file) {
      var allText = ''
      var rawFile = new window.XMLHttpRequest()
      rawFile.open('GET', file, true)
      rawFile.onreadystatechange = function () {
        if (rawFile.readyState === 4) {
          if (rawFile.status === 200 || rawFile.status === 0) {
            allText = rawFile.responseText
            // window.alert(allText)
          }
        }
      }
      rawFile.send()
      return allText
    },
    loadDataGame (board) {
      // window.alert(JSON.stringify(board))
      // clearTimeout(window.computerGame)
      clearInterval(timesColor.white)
      clearInterval(timesColor.black)
      this.activeChat = 'Chat'
      this.boardShow = board
      var parmsLoad = {
        user: this.active,
        board: this.user.club,
        range: {
          limit: 100,
          skip: 0
        }
      }
      // window.alert(JSON.stringify(this.board))
      this.loadUserConvert(parmsLoad, true)
      // cuando se esta visualizando un juego terminado
      // this.toast('visualizando juego terminado', 10)
      if (board.wins) {
        // console.log('visualizando juego terminado')
        this.boardShow = board
        // this.historyChange = true
        this.changeStateGame(board)
        // window.prettyPrint()
        // this.$nextTick(function () {
        /* var buttonFirst = document.getElementById('pgnButtonsfirst')
        if (buttonFirst) {
          buttonFirst.click()
        }*/
        // })
        // window.alert('juego terminado')
        return
      }
      // Torneos
      if (board.type === 'torneo') {
        this.boardShow = board
        this.changeStateGame(board)
        // this.$nextTick(function () {
          // window.alert('last2')
        /* var buttonLast = document.getElementById('pgnButtonslast')
        if (buttonLast) {
          buttonLast.click()
        }*/
          // this.countDown()
        // })
      } else {
        var data = {
          c: 'board',
          f: 'getBoard',
          data: board
        }
        // window.alert(this.$socket)
        // board.pgn = '1.e4 e5 2.Nf3 Nc6 3.Bc4 Bc5 4.b4 { This is the Evans Gambit in the Giuco Piano, a violent opening leading to attacks that was popular in Anderssens time. } 4...Bxb4 { Accepting gambits was a manly thing to do } 5.c3 Ba5 6.d4 { Gaining more time } 6...exd4 7.O-O d3 { Wasting time } 8.Qb3 { Threatening Bxf7 } 8...Qf6 9.e5 Qg6 { Black does not capture because he would open the e-file } 10.Re1! Nge7 11.Ba3 b5 { Trying to counterattack?! } 12.Qxb5 Rb8 13.Qa4 Bb6 14.Nbd2 Bb7 15.Ne4 Qf5 { Note that the king is still stuck in the center } 16.Bxd3 { Threatening a discovery with Nd6+, winning the queen } 16...Qh5 17.Nf6+ { Forces a capture of the knight. After gxf6 exf6, white rooks will be able to attack down the e-file at blacks exposed king. That is why you have to castle early! } 17...gxf6 18.exf6 Rg8 19.Rad1! { Getting another rook in the fight. } 19...Qxf3 { Oh no! Black threatens mate by Qxg2 and the g pawn is pinned. } 20.Rxe7+ Nxe7 { Forced checkmate for white now } 21.Qxd7+!! { White has to keep on checking since black is threatening mate. } 21...Kxd7 ( 21...Kf8 22.Qxe7# ) 22.Bf5+ { The king has to move because of double check } 22...Ke8 { Now can you see it? } ( 22...Kc6 { allows an immediate } 23.Bd7# ) 23.Bd7+ Kf8 ( { or } 23...Kd8 ) 24.Bxe7# { Mate!! }  1-0'
        if (this.$socket !== undefined) {
          this.$socket.emit('event', data, function (...callbacks) {
            if (!callbacks[0] && callbacks[1].board && callbacks[1].board.pgn) {
              this.activeChat = 'Chat'
              var board = callbacks[1].board
              // window.alert(JSON.stringify(board))
              this.boardShow = board
              this.times = callbacks[1].times
              // this.historyChange = true
              this.changeStateGame(board)
              // window.alert('last')
              // this.$nextTick(function () {
              /* var buttonLast = document.getElementById('pgnButtonslast')
              if (buttonLast) {
                buttonLast.click()
              }*/
              // })
              this.countDown()
            } else {
              // window.alert('No hay tablero quiza')
              // this.board = {'urls': '', 'type': 'public', 'pgn': '[Event "Hoogovens"]\n\n[Site "Wijk aan Zee"]\n\n[Date "1999.01.20"]\n\n[Round "4"]\n\n[White "Kasparov, Gary"]\n\n[Black "Topalov, Veselin"]\n\n[Result "1-0"]\n\n[ECO "B07"]\n\n[WhiteElo "2812"]\n\n[BlackElo "2700"]\n\n[Annotator "Moreno Ruiz,J"]\n\n[PlyCount "87"]\n\n[EventDate "1999.??.??"]\n\n[EventType "team"]\n\n1. e4 d6 2. d4 Nf6 3. Nc3 g6 {la defensa Pirc, ha planteado el negro, arriesgada, como el estilo del GM Bulgaro, cede el centro y la iniciativa a las blancas,} 4. Be3 Bg7 5. Qd2 {El blanco plantea un esquema de ataque tipico contra un fianchetto: Cambiarlo con Ah6.} c6 6. f3 b5 {El negro intenta ganar espacio en el flanco de dama para contrarrestar el dominio central del blanco, aunque esto es una estrategia dudosa.} ( 6... O-O {Esto será muy arriesgado para el negro, pues otorga al blanco un plan de ataque sobre el flanco de rey claro y directo.} 7. Bh6 Nbd7 8. h4$1 b5 9. h5$1$16 ) 7. Nge2 {Las blancas no quieren definir el enroque largo tan pronto, y hacen una jugada muy util, sin abandonar la posibilidad del enroque corto.} Nbd7 {El negro pretende llevar un Cc4.} 8. Bh6 {[#]El blanco cumple con una parte de su estrategia, consistente en cambiar el fuerte alfil negro.} Bxh6 ( 8... O-O 9. h4$1 {Cederá un ataque peligroso al blanco, siguiendo con Ph5. Esto es un plan temático en muchas posiciones para atacar el enroque corto fianchettado del negro.} ) 9. Qxh6 Bb7 {Las negras preparan el enroque largo, donde el rey estará mas seguro.} 10. a3 {Una jugada de espera util.} ( 10. O-O-O {las negras podian continuar con} b4 {con la idea de Da5 y Cb6 planteando algunos problemas.} ) e5 11. O-O-O Qe7 {Preparando el enroque largo.} 12. Kb1$1 {El principio de un gran plan de Kasparov, dedicado a atacar tambien el enroque largo del blanco!} a6 13. Nc1 O-O-O 14. Nb3$1 {[#]Esta era la idea de Rb1! El caballo se incorpora en el ataque con Ca5, y el rey será perseguido en el flanco de dama.} exd4 15. Rxd4 c5 16. Rd1 Nb6 17. g3$1 {Incorporando el alfil en el ataque!} Kb8 18. Na5 Ba8 19. Bh3 d5$5 {[#] Topalov se resiste a un juego pasivo y abre el centro, ¡pero ahora su rey expuesto otorga al blanco multitud de temas!} 20. Qf4+ Ka7 21. Rhe1 d4$5 22. Nd5$1 {¡Refutando toda la idea del negro! Una jugada pasiva de Kasparov hubiera dado al negro la iniciativa.} ( 22. Na2$6 Rhe8$11 ) Nbxd5 {La partida sera muy dificil de seguir si no voy exponiendo las distintas alternativas tacticas, por lo tanto de aqui en adelante deberemos acompanarnos de analisis de variantes para poder disfrutar, del ingenio y talento creador del " Ogro de Baku ".} ( 22... Bxd5$2 23. exd5 Qd6 24. Nc6+ Ka8 25. Re7 {Con posicion ganadora.} ) ( 22... Nfxd5$2 23. exd5 {Y la dama negra tiene un problema de sobrecarga ya que tiene que proteger, dos puntos, la entrada de la dama blanca por c7 y el peon de f7.} Qd6 24. Qxf7+ {Con ventaja ganadora, para el blanco.} ) 23. exd5 Qd6 24. Rxd4$3 {[#]En realidad hoy todavia es dificil evaluar perfectamente si es del todo correcta esta jugada pero desde el punto de vista artistico, humano es sin duda genial, especialmente cuando las blancas tení­an a mano un final equilibrado con 24. Cc6.} ( 24. Nc6+ {Era la alternativa solida.} Bxc6 25. Qxd6 Rxd6 26. dxc6 Rxc6 27. Re7+ Kb6 28. Rxf7 Re8$11 ) cxd4$2 ( 24... Qxf4 25. Rxf4 Nxd5 26. Rxf7+ Kb6 27. Nb3 Bc6 {Con pequeña ventaja blanca} ) ( 24... Bxd5$5 {Será muy interesante y compleja.} ) 25. Re7+$3 {Un mazazo sorprendente. ¡¡La torre no puede capturarse!!} Kb6 ( 25... Qxe7$2 26. Qxd4+ Kb8 27. Qb6+ Bb7 28. Nc6+ Ka8 29. Qa7# ) 26. Qxd4+ Kxa5 {No hay mas remedio que emprender una arriesgada fuga del rey.} ( 26... Qc5 27. Qxf6+ Qd6 ( 27... Kxa5$4 28. b4+ ) 28. Rxf7 Qxf6 ( 28... Kxa5 29. Qc3+ b4 30. axb4+ Qxb4 31. Qc7+ Kb5 ( 31... Ka4 32. Rf4 ) ( 31... Qb6 32. b4+ Kb5 33. Bf1+ {ganando.} ) 32. Bf1+ Ka4 33. Rf4 {ganando.} ) 29. Rxf6+ Kc5 ( 29... Kxa5$4 30. b4+ Ka4 31. Rxa6# ) 30. Nb3+ Kxd5 31. Rxa6 {Con ventaja blanca.} ) 27. b4+ Ka4 28. Qc3 {amenazando Db3 mate.} Qxd5 29. Ra7$1 {[#]} Bb7 {Unica, ya que a} ( 29... Rd6 30. Kb2 {Amenazando Db3} Qd4 31. Qxd4 Rxd4 32. Rxa6# ) 30. Rxb7 Qc4$6 ( 30... Rhe8$5 31. Rb6 Ra8 32. Rxf6 {Con pequeña ventaja blanca.} Qc4 33. Qxc4 bxc4 34. Kb2 Re7 35. Rc6 Kb5 36. Rc5+ Kb6 37. Rxc4$14 ) 31. Qxf6 Kxa3 {Todo esto parece una fuga hacia delante, no habia alternativas ya que las blancas amenazaban el peon de a6.} ( 31... Rd1+ 32. Kb2 Qd4+ ( 32... Ra8 33. Qb6 Qd4+ 34. Qxd4 Rxd4 35. Rxf7 a5 36. Be6 axb4 37. Bb3+ Ka5 38. axb4+ Kb6 {No era posible capturar el peon a causa de c3.} 39. Rxh7 {Con final ganador.} ) 33. Qxd4 Rxd4 34. Rxf7 Rd6 35. Re7 Ra8 36. Be6 {Con posicion ganadora.} ) 32. Qxa6+ Kxb4 {[#] Parece que la audaz y arriesgada fuga de rey va a tener exito, pero...} 33. c3+$1 Kxc3 34. Qa1+$1 Kd2 {unica tambien.} ( 34... Kb4 35. Qb2+ Qb3 ( 35... Kc5 36. Rc7+ ) ( 35... Ka5 36. Qa3+ Qa4 37. Ra7+ Kb6 38. Rxa4 ) ( 35... Ka4 36. Ra7# ) 36. Rxb5+ ) 35. Qb2+ Kd1 {Momento critico!! El negro parece haberse salido con la suya, y ahora el rey negro colabora en el ataque. ¡Incluso el rey blanco se ve amenazado de Dd3+!, pero hay un recurso inesperado que confirma todo el juego blanco hasta aquí­.} ( 35... Ke3 36. Re7+ Kxf3 37. Qg2# ) 36. Bf1$3 {[#]Curioso que despues de llevar el rey por todo el tablero la clave de la combinacion de entrega de torre en d4 de la jugada 24, este justo aqui doce jugadas mas adelante, y sin la cual nada de lo anterior se hubiera podido hacer.} Rd2 {La mejor defensa.} ( 36... Qxf1 37. Qc2+ Ke1 38. Re7+ Qe2 39. Qxe2# ) 37. Rd7$1 {Una clavada mortal!! Elegancia absoluta en esta jugada!!} Rxd7 38. Bxc4 bxc4 39. Qxh8$1 {Un detalle elegante y necesario. El negro todaví­a tiene cierta resistencia desesperada.} Rd3 40. Qa8 c3 41. Qa4+ Ke1 42. f4 f5 43. Kc1 Rd2 44. Qa7$1 {Otra elegante jugada larga de dama. El negro pierde ahora mas peones, con lo que Topalov abandona. ¡UNA VERDADERA OBRA DE ARTE!  Segun una votación en una importante revista, la mejor partida del siglo XX.} ( 44. Qa7 h5 ( 44... Rxh2$2 45. Qg1+$18 ) 45. Qb6 h4 46. Qxg6$18 ) 1-0', '_id': '631c3f1e08dd9309e84142d7', 'public': 'true', 'all': 'false', 'club': 'General', 'name': 'PARTIDA DE EJEMPLO', 'lesson': '', 'category': '', 'time': '90', 'elo': '1500', 'incremento': '0', 'created': '2022-09-10T07:39:09.989Z', '__v":0,"motiv': 'closed', 'u1': 'Kasparov, Gary', 'u2': 'Topalov, Veselin', 'wins': 'black'}
              // this.board = {'urls': '', 'type': 'public', 'pgn': '1. e4', '_id': '631c3f1e08dd9309e84142d7', 'public': 'true', 'all': 'false', 'club': 'General', 'name': 'PARTIDA DE EJEMPLO', 'lesson': '', 'category': '', 'time': '90', 'elo': '1500', 'incremento': '0', 'created': '2022-09-10T07:39:09.989Z', '__v":0,"motiv': 'closed', 'u1': 'Ejemplo', 'u2': 'Ejemplo', 'wins': 'black'}
              /* var chosenNumber = this.getRandomInt(1, 5)
              var pgnFile = '../../../static/' + chosenNumber + '.pgn'
              this.board = this.readTextFile(pgnFile)
              */
              this.board = []
              this.changeStateGame(this.board)
              // console.log('pc VS pc')
              // this.pcVsPcInit()
              /* document.getElementById('pgnMoves').textContent = ''
              document.getElementById('pgnButtons').textContent = ''
              document.getElementById('pgnHeader').textContent = ''
              document.getElementById('pgnError').textContent = ''
              document.getElementById('pgnBoard').textContent = ''
              var this.Width = document.getElementById('middle').clientWidth
              // ../../../static/1.pgn
              var winWidth = Math.min(window.innerWidth, window.outerWidth)
              // var chosenNumber = this.getRandomInt(1, 5)
              // window.pgnView({inner: 'pgnBoard', moves: 'pgnMoves', button: 'pgnButtons', fen: 'pgnFen', header: 'pgnHeader', error: 'pgnError'}, {pgnFile: '../../../static/' + chosenNumber + '.pgn', movesWidth: '80%', startPlay: 1, showFen: false, colorMarker: 'cm-small', width: Width, locale: 'es', orientation: window.orientationg, coordsFactor: 0.6, coordsInner: winWidth < 600, timerTime: 2000, autoplay: true, headers: false})
              window.pgnView({inner: 'pgnBoard', moves: 'pgnMoves', button: 'pgnButtons', fen: 'pgnFen', header: 'pgnHeader', error: 'pgnError'}, {position: 'start', movesWidth: '80', showFen: false, colorMarker: 'cm-small', width: Width, locale: 'es', orientation: window.orientationg, coordsFactor: 0.6, coordsInner: winWidth < 600, timerTime: 2000, autoplay: true, headers: false})
              // window.pgnView({inner: 'pgnBoard', moves: 'pgnMoves', button: 'pgnButtons', fen: 'pgnFen', header: 'pgnHeader', error: 'pgnError'}, {pgnFile: 'https:/www.zonetuner.com/' + chosenNumber + '.pgn', movesWidth: '80%', startPlay: 1, showFen: false, colorMarker: 'cm-small', width: Width, locale: 'es', orientation: window.orientationg, coordsFactor: 0.6, coordsInner: winWidth < 600, timerTime: 2000, autoplay: true, headers: false})
              // var buttonLast = document.getElementById('pgnButtonslast')
              // if (buttonLast) {
              //  buttonLast.click()
              // } */
            }
          }.bind(this))
        }
      }
    },
    /* FinishMoveCallback (move) {
      // var from = move & 0xFF
      // var to = (move >> 8) & 0xFF
      // var sfrom = Garbochess.FormatSquare(from)
      // var sto = Garbochess.FormatSquare(to)
      /* this.chess.move({
        from: sfrom,
        to: sto,
        promotion: 'q'
      })*
      // window.alert('finish')
      document.getElementById('pgnMoves').textContent = ''
      document.getElementById('pgnButtons').textContent = ''
      document.getElementById('pgnHeader').textContent = ''
      document.getElementById('pgnError').textContent = ''
      var Width = document.getElementById('middle').clientWidth
      var pgnBoard = 0
      if (this.board.pgn !== 'none') {
        pgnBoard = window.pgnEdit({inner: 'pgnBoard', moves: 'pgnMoves', button: 'pgnButtons', fen: 'pgnFen', header: 'pgnHeader', error: 'pgnError'}, {pgn: this.board.pgn, movesWidth: '80%', showFen: true, colorMarker: 'cm-small', width: Width, startPlay: this.chess.fen(), position: this.chess.fen(), locale: 'es', orientation: window.orientationg, coordsFactor: 0.6, coordsInner: winWidth < 600, headers: false})
      } else {
        pgnBoard = window.pgnEdit({inner: 'pgnBoard', moves: 'pgnMoves', button: 'pgnButtons', fen: 'pgnFen', header: 'pgnHeader', error: 'pgnError'}, {width: Width, movesWidth: '80%', showFen: true, colorMarker: 'cm-small', position: 'last', locale: 'es', orientation: window.orientationg, coordsFactor: 0.6, coordsInner: winWidth < 600, headers: false})
      }
      window.pgnBoardBase = pgnBoard.boardBase
      window.ground = pgnBoard.board
      if (document.getElementById('middle')) {
        document.getElementById('pgnBoard').style.height = Width + 'px'
        document.getElementById('pgnBoard').style.width = Width + 'px'
        document.body.dispatchEvent(new window.Event('chessground.resize'))
      }
      // window.ground.move(sfrom, sto)
      var fen = this.chess.fen()
      var options = {
        animation: false,
        orientation: window.orientationg,
        fen: fen,
        highlight: {
          lastMove: true,       // add last-move class to squares
          check: true          // add check class to squares
        },
        drawable: {
          enabled: true, // can draw
          visible: true
        },
        movable: {
          free: false, // all moves are valid - board editor
          color: 'both', // color that can move. "white" | "black" | "both" | null
          dests: {}, // valid moves. {a2: ["a3", "a4"], b1: ["a3", "c3"]} | null
          dropOff: 'revert', // when a piece is dropped outside the board. "revert" | "trash"
          showDests: true // add the move-dest class to squares
        },
        /* premovable: {
          enabled: true,
          showDests: true,
          current: ['e2', 'e4']         // keys of the current saved premove ["e2", "e4"] | null
        }, *
        resizable: true
      }
      window.ground.set(options)
      /* this.ground.setAutoShapes([{
        orig: sfrom,
        dest: sto,
        brush: 'blue'
      }, {
        orig: 'e2',
        dest: 'b3',
        brush: 'red'
      }]) *
      this.chessToColor(this.chess)
      if (this.$route.path === '/home') {
        if (!this.chess.game_over()) {
          window.computerGame = setTimeout(function () {
            this.timerfunction(fen)
          }.bind(this), 10000)
        } else {
          clearTimeout(window.computerGame)
        }
      }
      if (document.getElementById('searchInput') && document.getElementById('analisisModal').style.display !== 'none') {
        window.onload()
        document.getElementById('searchInput').value = window.pgnBoardBase.chess.fen()
        // document.getElementById('searchInput').value = window.pgnBoardBase.getPgn().write_pgn()
        document.getElementById('searchInput').dispatchEvent(new window.Event('change'))
      }
    }, */
    timerfunction (fen) {
      // window.alert(fen)
      // Garbochess.InitializeFromFen(fen)
      // Garbochess.Search(this.FinishMoveCallback, 7, null)
    },
    resizeBoard () {
      if (document.getElementById('middle') && document.getElementById('pgnBoard')) {
        this.Width = document.getElementById('middle').clientWidth
        var height = document.getElementById('content_Visor').clientHeight
        this.Width = this.Width > height - 100 ? height - 100 : this.Width // document.getElementById('middle').clientWidth
        var winWidth = Math.min(window.innerWidth, window.outerWidth)
        var Left = 0
        var LeftAnalisis = 0
        if (winWidth >= 782) {
          // this.Width = window.innerHeight - 160 < this.Width ? window.innerHeight - 160 : this.Width
          if (this.Width < document.getElementById('middle').clientWidth) {
            var rightMore = document.getElementById('middle').clientWidth - this.Width
            // window.alert(rightMore)
            Left = rightMore / 2 + 'px'
            LeftAnalisis = (rightMore / 2) - 3 + 'px'
          }
        }
        if (document.getElementById('analisisVertical') && document.getElementById('analisisVertical').style.display !== 'none') {
          this.Width = this.Width - 20
        }
        document.getElementById('pgnBoard').style.left = Left
        document.getElementById('pgnBoard').style.height = this.Width + 'px'
        document.getElementById('pgnBoard').style.width = this.Width + 'px'
        document.getElementById('analisisVertical').style.left = LeftAnalisis
        document.getElementById('analisisVertical').style.height = this.Width + 6 + 'px'
        // Jquery('#pgnBoard').load(window.location.href + '#pgnBoard')
        // this.toast('<span>Width: ' + Width + '</span>', 2000, 'rounded')
        document.body.dispatchEvent(new window.Event('chessground.resize'))
      }
    },
    pcVsPcInit () {
      // window.alert('')
      // Garbochess.ResetGame()
      setTimeout(function () {
        var fen = 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1'
        this.timerfunction(fen)
      }.bind(this), 2000)
    },
    checkResources (fen) {
      // window.alert(JSON.stringify(this.board))
      if (this.board.urls !== undefined && this.board.urls.length > 0) {
        var iFound = this.board.urls.indexOf(fen)
        if (iFound >= 0) {
          // window.alert(fen)
          var nInitUrls = iFound + fen.length + 1
          var nFinUrls = this.board.urls.indexOf(';', nInitUrls)
          var sql = this.board.urls.substring(nInitUrls, nFinUrls)
          this.tokens.length = 0
          var _self = this
          sql.replace(/\{(.*?)}/g, function (a, b) {
            var splitToken = b.split('=')
            var token = {}
            token.name = splitToken[0]
            token.url = splitToken[1]
            token.type = ''
            token.type = splitToken[1].includes('http') ? 'link' : token.type
            token.type = splitToken[1].endsWith('pdf') ? 'pdf' : token.type
            token.type = splitToken[1].endsWith('pgn') ? 'pgn' : token.type
            token.type = splitToken[1].includes('embed') && splitToken[1].includes('youtube') ? 'youtube' : token.type
            token.type = splitToken[1].endsWith('png') || splitToken[1].endsWith('jpg') || splitToken[1].endsWith('jpeg') || splitToken[1].endsWith('gif') ? 'image' : token.type
            _self.tokens.push(token)
          })
          // window.alert('urls: ' + JSON.stringify(this.tokens))
          setTimeout(function () {
            this.$broadcast('modal::open', 'modalRecursos')
          }.bind(this), 300)
        }
      }
    }
  },
  watch: {
    newEmoji (newVal, oldVal) {
      this.chattext += newVal
      document.getElementById('textChatInput').focus()
    },
    activeChat (newVal, oldVal) {
      if (newVal === 'Visor') {
        this.changeStateGame(this.board)
        this.chatRecibido = false
      }
      if (this.activeChat === 'Chat') {
        this.chatRecibido = false
        this.scrollBottom()
      }
    },
    board (newVal, oldVal) {
      // window.alert(JSON.stringify(newVal) + ' ' + JSON.stringify(oldVal))
      if (newVal !== undefined && JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
        // window.alert('board')
        this.loadDataGame(newVal)
        this.result = {
          wins: '',
          motiv: ''
        }
      }
    },
    /* boardFiles (newVal, oldVal) {
      this.getTorneos()
    },*/
    myPGNReload (val, oldVal) {
      // window.alert(val)
      if (val === 'reload') {
        this.historyChange = true
        // window.alert(val)
        this.changeStateGameSimple()
        document.getElementById('myPGNReload').value = ''
        document.getElementById('myPGNReload').dispatchEvent(new window.Event('change'))
      }
    },
    myPGNValue (val, oldVal) {
      // window.alert('myPGNValue changed ' + val)
      // window.alert(' myPGNValue: ' + this.userFrom)
      // window.alert(JSON.stringify(this.board))
      // document.getElementById('myPGNValueP').textContent = val
      if (this.isOwner() && this.board.u1 === this.board.u2 && val !== oldVal) {
        // window.alert(' myPGNValue: ' + this.userFrom + this.boardShow.u1 + this.user.username)
        // this.sendPGNtoTeacher()
        this.changePGN()
      }
      // this.userFrom = this.user.username
      // window.alert('e' + this.userFrom)
    },
    myFENValue (val, oldVal) {
      if (document.getElementById('searchInput')) {
        // window.historyMoveFen(val)
        document.getElementById('searchInput').value = val
        // document.getElementById('searchInput').value = window.pgnBoardBase.getPgn().write_pgn()
        document.getElementById('myFENValueP').textContent = val
        if (document.getElementById('analisisModal').style.display !== 'none') {
          document.getElementById('searchInput').dispatchEvent(new window.Event('change'))
        }
      }
      this.$broadcast('modal::close', 'some', 'modalRecursos')
      this.checkResources(val)
      // window.alert(JSON.stringify(this.board.user))
      // window.alert(this.userFrom + '' + this.boardShow.u1)
      if (this.board.u1 === this.board.u2 && val !== oldVal && this.boardShow !== undefined && this.userFrom !== this.boardShow.u1 && this.userFrom === this.user.username) {
        // window.alert(' myFENValue: ' + this.userFrom + this.boardShow.u1 + this.user.username)
        // this.sendPGNtoTeacher()
      }
      if (window.pgnBoardBase !== undefined && window.pgnBoardBase !== null && window.pgnBoardBase.chess !== undefined) {
        this.turn = (window.pgnBoardBase.chess.turn() === 'w') ? 'white' : 'black'
      }
      // this.soundPlay()
      // this.userFrom = this.user.username
      // window.alert('e' + this.userFrom)
    },
    turn (newVal, oldVal) {
      clearInterval(timesColor[oldVal])
      clearInterval(timesColor[newVal])
      if (this.boardShow !== undefined && !this.boardShow.wins) {
        this.countDown()
      }
    }
  },
  ready () {
    setTimeout(function () {
      // document.body.dispatchEvent(new window.Event('chessground.resize'))
      this.resizeBoard()
    }.bind(this), 500)
  },
  created () {
    window.addEventListener('resize', this.onResize)
    clearTimeout(window.computerGame)
    clearInterval(timesColor.white)
    clearInterval(timesColor.black)
    /* var options = {
      orientation: 'white',
      viewOnly: false,
      movable: {
        free: false, // all moves are valid - board editor
        color: 'both', // color that can move. "white" | "black" | "both" | null
        dests: {}, // valid moves. {a2: ["a3", "a4"], b1: ["a3", "c3"]} | null
        dropOff: 'revert', // when a piece is dropped outside the board. "revert" | "trash"
        showDests: true // add the move-dest class to squares
      },
      highlight: {
        lastMove: true,       // add last-move class to squares
        check: true          // add check class to squares
      },
      drawable: {
        enable: true,
        visible: true
      }
    }*/
    if (this.board !== undefined) {
      window.orientationg = this.isHumanVsAnalisis() === false && this.user.username === this.board.u2 ? 'black' : 'white'
    }
    setTimeout(function () {
      this.loadDataGame(this.board)
      this.resizeBoard()
    }.bind(this), 200)
    // window.alert(JSON.stringify(this.$route.params))
    // FOR TEST ONLY
    if (this.$route.params.u2 !== '' && this.$route.params.u1 === 'only') {
      var _self = this
      // window.alert(JSON.stringify(_self.$route.params))
      if (this.isPgnFile(this.$route.params.u2) === false) {
        Board.filterid(_self, { id: _self.$route.params.u2 }).then(function (response) {
          const data = JSON.parse(response)
          _self.board = data
        }, function (response) {
          _self.error = response.data
          // window.alert(JSON.stringify(_self.error))
          _self.changeStateGame(null, true)
        })
      } else {
        _self.changeStateGame(null, true)
      }
    }
  }
}
</script>


<style scoped>
  @import '../../../static/libs/simplechessboard.min.css';
  .userTurn {
    color: white ;
    font-size: large;
  }
  .check {
    background: radial-gradient(ellipse at center, rgb(123, 255, 0) 40%, rgba(231, 0, 0, 1) 40%, rgba(169, 0, 0, 0) 89%, rgba(158, 0, 0, 0) 100%);
  }
 
.emojiclass {
  font-size: small;
}
.loadbar:before {
  content: "";
  margin-top: -3px;
  
  width: calc(100% - 0px);
  /* height: calc(100% + 6px);
  position: absolute;*/
  z-index: 6;
 
}
  .loadbar
    {
      top: -3px;
         width:15px;
         background-color: #5c005c; /*var(--thumbBG);*/
         position:relative;
         float:left;
         border:1px solid;
        
    }
    .bar
    {
        width:100%;
        display:block;        
        font-family:arial;
        font-size:12px; 
        background-color:white;
        color:#000;       
        position:absolute;
        bottom:0;        
    }
    .borderround
    {
        max-height: 400px;
    overflow-y: scroll;
    min-height: 15px;
    border: 1px solid #5c005c;
    border-radius: 5px;
    padding: 5px;
    margin-top: 10px;
    margin-bottom: 10px;
    /* background: url(/static/img/logo.db1b338.png) right bottom #d0d0d0;*/
    background: right bottom #ffffff;
    background-blend-mode: overlay;
    background-size: auto 100px;
    background-repeat: no-repeat;
    }
    /*** Nuevo sistema de movimientos ***/
    .nocomments .moves .move .comment {
    display: none; 
    }
    .nocomments .moves .move a 
    {
        width: 100%;
        padding-left: 5px;
        height: 28px;
        line-height: 1.75em;
        /*padding: 0 .3em 0 .5em;*/
    }
    .nocomments .moves .move :hover
    {
        width: 100%;
        line-height: 1.75em;
        /*padding: 0 .3em 0 .5em;*/
    }
    .nocomments .moves .move a:hover {
        border: 0px black;
        background-color: #1B5E20;
        cursor: pointer;
        color: white;
        line-height: 1.75em;
        height: fit-content;
        /*padding: 0 .3em 0 .5em;*/
    }
    .nocomments .move {
        flex: 0 0 50%;
        display: inline-flex ;
        width: 100%;
        line-height: 1.75em;
        /*padding: 0 .3em 0 .5em;*/
    }
    .nocomments .moveNumber {
        flex: 0 0 35%;
        display: inline-flex;
        justify-content: center;
        border-inline-end: 1px solid var(--c-border);
        background: #5c005c;
        color: white;
    }
    .nocomments .moves {
        display: flex;
        flex-flow: row wrap;
        align-content: flex-start;
    }
    .nocomments #pgnMovesEvents, #pgnMoves {
    max-height: 350px;
    overflow-y: scroll;
    /* min-height: auto; */
    border: 1px solid #5c005c;
    border-radius: 5px;
    padding: 1px;
    margin-top: 10px;
    margin-bottom: 10px;
    }
    .title
    {    width: 100%;
    text-align: center;
    background: #5c005c;
    color: white;
    padding: 5px;
    border-radius: 5px;
  }
  .noboardmiddle #pgnBoard {
    display: none;  
  }
    /***********/
</style>



// WEBPACK FOOTER //
// boardVisor.vue?605d1146